import { Box, Divider as MuiDivider } from '@mui/material';

type DividerProps = {
  value: 'line' | 'space';
  /* Deprecated - use spaceMobile and spaceDesktop. Remove after 28.11.26 */
  space?: number;
  spaceMobile?: number;
  spaceDesktop?: number;
};

const Divider = ({ value, space, spaceMobile, spaceDesktop }: DividerProps) => {
  if (value === 'line') return <MuiDivider sx={{ my: 4 }} />;
  const pt =
    spaceMobile != null || spaceDesktop != null
      ? { xs: spaceMobile ?? space ?? 4, md: spaceDesktop ?? space ?? 4 }
      : space;
  return <Box sx={{ pt }} />;
};
export default Divider;
